/* src/app/order/components/additional-questions/audit-dates/initial-certification-dates/initial-certification-dates.style.scss */
.audit-dates {
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
}
.audit-dates .audit-date {
  width: 100%;
  min-width: 292px;
  flex-basis: 49%;
}
.audit-dates .audit-date:first-child {
  margin-right: 10px;
}
.audit-dates .audit-date.stage-1-date {
  margin-right: 10px;
}
.audit-dates .audit-date .date-label {
  font-family: Arial, sans-serif;
  font-size: 12px;
  font-weight: bold;
  line-height: 1.33;
  color: #007d40;
  text-transform: uppercase;
  display: block;
  margin-bottom: 10px;
}
.info-icon {
  vertical-align: middle;
  fill: #91bbff !important;
}
.info-icon:hover {
  fill: #0044b1 !important;
  cursor: pointer;
}
.info-icon.clicked {
  fill: #0044b1 !important;
}
.pre-audit-date-info {
  line-height: 1.33;
}
.pre-audit-date-info-header {
  font-size: 12px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.33;
  letter-spacing: normal;
}
@media screen and (max-width: 1096px) {
  .audit-dates .audit-date {
    flex-basis: 100%;
  }
  .audit-dates .audit-date:first-child {
    margin-right: 0;
  }
  .audit-dates .audit-date.stage-1-date {
    margin-right: 0;
  }
}
/*# sourceMappingURL=initial-certification-dates.style.css.map */
